<template>
    <svg xmlns="http://www.w3.org/2000/svg" :width :height :viewBox="viewBox" role="presentation">
        <g :fill="color">
            <slot />
        </g>
    </svg>
</template>
  
<script setup lang="ts">
interface Props {
    width?: string | number,
    height?: string | number,
    color?: string,
    size?: number,
    vbSize?: number
}
import { computed } from 'vue'
const props = withDefaults(defineProps<Props>(), {
    width: 24,
    height: 24,
    color: 'currentColor',
    size: 1
})

const width = +props.width * props.size
const height = +props.height * props.size

const viewBox = computed(() => {
    const vbW = props.vbSize ?? +props.width
    const vbH = props.vbSize ?? +props.height
    return `0 0 ${vbW} ${vbH}`
})
</script>

